exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.activityIcons[data-v-b1bcd95a] {\n  font-size: 13px;\n  line-height: 32px;\n}\n.activityIcons span[data-v-b1bcd95a] {\n    white-space: nowrap;\n    padding-right: 1em;\n}\n.fa[data-v-b1bcd95a] {\n  font-size: 16px;\n  margin-right: 0.3em;\n}\n.fa-bolt[data-v-b1bcd95a] {\n  color: #FF8800;\n}\n.fa-clock-o[data-v-b1bcd95a], .fa-child[data-v-b1bcd95a], .fa-comments-o[data-v-b1bcd95a], .fa-tree[data-v-b1bcd95a], .fa-users[data-v-b1bcd95a], .fa-map-marker[data-v-b1bcd95a] {\n  color: #00B48D;\n}\n.fa-wheelchair[data-v-b1bcd95a] {\n  color: #00BCD4;\n}\n.location[data-v-b1bcd95a] {\n  font-size: 0.9rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1bcd95a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Activity/DescriptionHeader.vue
// module id = 670
// module chunks = 3